import { format } from './locationConverter'
import { filter } from './object'
import { isNone, not } from './primitive'

const formatApiQuery = (query) => {
  const formatted = format(query)
  return filter(formatted, not(isNone))
}

export { formatApiQuery as formatJobSearchQuery, formatApiQuery as formatCompanySearchQuery, formatApiQuery }
